import Vue from "vue";
import Router from "vue-router";
import store from "@/config/store.js";

import Users from "../components/dashboard/users/Users";
import NewsItems from "../components/dashboard/news/NewsItems";
import Events from "../components/dashboard/agenda/Events";
import Enrollments from "../components/dashboard/enrollments/Enrollments";
import Performances from "../components/dashboard/prestations/Performances";
import FAQ from "../components/dashboard/faq/FAQ";
import Branches from "../components/dashboard/branches/Branches";
import Images from "../components/dashboard/images/Images";
import Sponsors from "../components/dashboard/sponsors/Sponsors";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Login";
import Recover from "../pages/Recover";
import Activate from "../pages/Activate";
import Terms from "../pages/Terms";
import Code from "../pages/Code";
import Conduct from "../pages/CodeOfConduct";
import Privacy from "../pages/Privacy";

import Home from "../pages/Home";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/dashboard/",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "users",
          name: "Gebruikers",
          component: Users,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "news",
          name: "Nieuwsberichten",
          component: NewsItems,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "agenda",
          name: "Evenementen",
          component: Events,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "enrollments",
          name: "Inschrijvingen",
          component: Enrollments,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "performances",
          name: "Prestaties",
          component: Performances,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "images",
          name: "Afbeeldingen",
          component: Images,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "faq",
          name: "FAQ",
          component: FAQ,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "branches",
          name: "Takken",
          component: Branches,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "sponsors",
          name: "Sponsors",
          component: Sponsors,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "",
          name: "Gebruikers fallback",
          component: Users,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: false
      },
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "/terms",
      name: "terms",
      component: Terms,
      meta: {
        requiresAuth: false
      },
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "/code",
      name: "code",
      component: Code,
      meta: {
        requiresAuth: false
      },
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "/conduct",
      name: "conduct",
      component: Conduct,
      meta: {
        requiresAuth: false
      },
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: Privacy,
      meta: {
        requiresAuth: false
      },
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/recover",
      name: "recover",
      component: Recover,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/reset",
      name: "activate",
      component: Activate,
      meta: {
        requiresAuth: false
      },
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "*",
      redirect: "/home"
    }
  ]
});
router.beforeEach((to, from, next) => {
  const moment = require("moment");
  var valid = false;
  if (store.getters.isLoggedIn) {
    if (moment().diff(store.getters.expirationDate, "milliseconds", true) < 0) {
      valid = true;
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (valid) {
      next();
      return;
    } else {
      console.log(store.getters.expirationDate);
      store.dispatch("logout");
      console.log("Logging out");
    }
  }
  if (valid) {
    next();
  } else {
    store.dispatch("logout");
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js